import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ThirdPartsAuthenticationList } from '~modules/thirdparts/common/entities/third-parts-authentication-list.entity';
import { ThirdPartsZervantAuthenticationManualCreateUpdateRequest } from '../entities/third-parts-zervant-authentication-manual-create-update-request.entity';
import { environment } from 'src/environments/environment';

@Injectable()
export class ThirdPartsZervantAuthenticationService {

  constructor(private readonly http: HttpClient) { }

  public list$(): Observable<ThirdPartsAuthenticationList[]> {
    const path = `${environment.apiURL}/third-parts/zervant/authentication/list`;
    return this.http.get<ThirdPartsAuthenticationList[]>(path);
  }

  public createOrUpdate$(request: ThirdPartsZervantAuthenticationManualCreateUpdateRequest) {
    const url = `${environment.apiURL}/third-parts/zervant/authentication`;

    return this.http.post<void>(url, request);
  }
}